export default __webpack_public_path__ + "static/soc-2-compliance-for-saas-c6985c7437152e5334f53a79768320b2.png";